<template>
  <b-modal
    id="support-modal"
    class="support-full-screen-modal"
    header-class="support-modal-header"
    ref="modal"
    :cancel-title="$t('Cancel')"
    :ok-title="$t('Send')"
    @ok="handleSubmit"
    centered
    ok-variant="primary">

    <div>
      <p class="modal-text" v-html="$t('support.modal.welcome')"></p>
      <p class="modal-text mt-2" v-html="$t('support.modal.fill.in')"></p>
    </div>

    <b-form-group
      :label="$t('support.modal.feedback.type')"
      label-for="feedback-type-input"
      class="small-text mt-2">
      <b-form-select
        id="feedback-type-input"
        v-model="feedbackType"
        required>
        <option v-for="type in feedbackTypes" :value="type.value">
          {{ $t(type.text) }}
        </option>
      </b-form-select>
    </b-form-group>


    <b-form-group
      :label="$t('support.modal.content')"
      class="small-text"
      :invalid-feedback="content.invalidFeedback"
      label-for="content-input">
      <b-form-textarea
        :state="content.state"
        id="content-input"
        required
        v-model="content.value">
      </b-form-textarea>

    </b-form-group>

    <template #modal-header="{ close }">
      <div  class="support-modal-header-content step4 w-100">
        <div class="support-container h-100">
          <h1 class="page-title" v-html="$t('support.modal.title')"/>
        </div>
      </div>
    </template>

  </b-modal>
</template>

<script>
import i18n from "../../i18n";
import api from "../../services/api";

export default {

  data() {
    return {

      feedbackType: "FEEDBACK_USER",
      feedbackTypes: [],

      content: {
        state: null,
        invalidFeedback: null,
        value: null,
      }
    };
  },

  mounted() {
    this.fetchFeedbackTypes()
  },

  methods: {
    handleSubmit(e){
      let data = new FormData()
      if(this.content.value === null) {
        this.content.state = false
        this.content.invalidFeedback = i18n.t('support.modal.content.error')
        e.preventDefault()
        return
      }
      data.append('feedbackType', this.feedbackType)
      data.append('content', this.content.value)

      api({
        method: "POST",
        url: '/user/sendFeedbackMail',
        data: data
      })
        .then(() => {
          this.resetModal()
          this.hideModal()
          this.successToast()
        })
        .catch(error => {
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this[invalidField]['state'] = false
            this[invalidField]['invalidFeedback'] = i18n.t(error.response.data.message)
          }
        })
    },

    fetchFeedbackTypes(){
      api({
        method: "GET",
        url: '/user/fetchFeedbackTypes',
      })
        .then((response) => {
          this.feedbackType = response.data[0].value;
          response.data.forEach(feedbackType => {
            this.feedbackTypes.push({
              value: feedbackType.value,
              text: feedbackType.text,
            })
          })
        })
    },

    hideModal () {
      this.$bvModal.hide('support-modal')
    },

    resetModal () {
      this.feedbackType = this.feedbackTypes[0].value
      this.content.value = null
      this.content.state = null
      this.content.invalidFeedback = null
    },

    successToast () {
      this.$bvToast.toast(this.$i18n.t('support.modal.success'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },
  }
};
</script>

<!-- not scoped car modal --><style>

#support-modal .modal-header{
  background-color: transparent !important;
  padding-bottom: 0;
}

#support-modal .modal-content,
#support-modal .modal-body,
#support-modal .modal-footer{
  background-color: var(--main-black-dark);
}

#support-modal .support-modal-header-content {
  position: relative;
  padding: 0;
  border-bottom: none;
}

.support-modal-img {
  max-width: 200px;
  min-width: 100px;
  z-index: 1;
}

#support-modal .modal-text{
  color: var(--main-grey-medium);
}

.support-modal-header {
  background-color: transparent !important;
  position: relative;
  margin-top: -20px;
  margin-right: -20px;
  margin-left: -20px;
}

.support-container {
  padding: 8px 18px;
}

@media (min-width: 992px) {
  .support-container {
    flex-direction: column;
  }
}

@media (max-width: 991px) {
  .support-container img {
    order: 2;
    align-self: center;
  }
  .support-container {
    text-align: center;
  }
}

#support-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

.support-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}
.support-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #support-modal .modal-content {
    display: flex;
    overflow: auto;
    padding: 10px;
  }
  #support-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
  #support-modal .modal-header {
    padding-top: 0;
  }
  .support-modal-img {
    margin-top: 20px;
    align-self: end;
  }
  .support-modal-subtitle {
    margin-top: 6px !important;
    margin-left: 0 !important;
  }
  #support-modal .modal-content {
    margin: 8px;
  }
  #support-modal .modal-text {
    padding: 0px;
  }
  #support-modal .support-modal-img {
    max-width: 100px;
  }
  #support-modal .support-container {
    padding-top: 32px;
    padding-bottom: 0px;
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (max-height: 852px) {
  #support-modal .modal-content {
    overflow: auto;
  }

  .support-modal-subtitle{
    font-size: 18px;
  }
  .support-modal-header-content, #support-modal, .support-container {
    padding: 2px 18px;
  }

  .modal-text {
    padding: 0px;
  }

}

</style>



// WEBPACK FOOTER //
// src/views/user/SupportModal.vue